import { Component, Input, Injector, Type, ViewContainerRef, ViewChild, AfterViewInit, OnInit } from '@angular/core';
import { IOptionalComponent } from '../../interfaces/IProjectHeader';
import { DynamicComponentService } from 'src/app/shared/dynamicComponentLoader/dynamicComponent.service';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';


@Component({
  selector: 'eic-equipment-and-capacities-container',
  templateUrl: './equipment-and-capacities-container.component.html',
  styleUrls: ['../../project-display.styles.scss',
              './equipment-and-capacities-container.component.scss']
})
export class EquipmentAndCapacitiesContainerComponent implements AfterViewInit {
  @Input() public optionalComponents$: Observable<IOptionalComponent[]>;
  @Input() public projectId: number;
  @Input() public discriminator: string;
  @Input() public project$: Observable<any>;

  components$: Observable<{ type: Type<any>,  data$: Observable<any> }[]>; //id: number,

  baseComponent = BaseComponent;


  constructor(private dynamicComponentService: DynamicComponentService) { }


  ngAfterViewInit(): void {
    // Assets fetch equipment from the dedicated /equipment endpoint; Projects
    // already carry equipment fields (eg. ccsTechnology) on the /api/project/{id} payload
    if (this.discriminator === 'Asset') {
      this.components$ = this.dynamicComponentService.getComponentList5(this.projectId);
    } else if (this.project$) {
      this.components$ = this.project$.pipe(
        switchMap(project => this.dynamicComponentService.getComponentListFromProject(project))
      );
    } else {
      this.components$ = of([]);
    }
  }
}


// base component to handle common styling

@Component({
  selector: 'base-component',
  template: '<ng-container #dynamicComponentContainer></ng-container>',
  styles: [`
    :host {
      display: block;
      padding: 10px;
      //border: 1px solid var(--sys-on-surface);
      background-color: var(--sys-surface-container-high);
      margin-bottom: 10px;
    }
  `]
})
export class BaseComponent implements OnInit, AfterViewInit {
  @Input() type: Type<any>;
  @Input() data$: Observable<any>;
  @ViewChild('dynamicComponentContainer', { read: ViewContainerRef, static: true }) container: ViewContainerRef;

  constructor() { }

  ngOnInit() {

  }

  loadComponent() {
    if (this.type) {
      // I'm not really sure what  this was trying to achieve
      // giving the component its own injector was probably what 
      // stopped the data from appearing
      // const componentRef = this.container.createComponent(this.componentType, {
      //   injector: Injector.create({
      //     providers: [{ provide: 'data', useValue: this.data }],
      //     parent: this.injector
      //   })
      //});

      // Pass the data to the dynamic componen - this works
      const componentRef = this.container.createComponent(this.type);
      componentRef.instance.data$ = this.data$;
    }
    else {
      console.error('Component type is undefined');
    }
  }
  ngAfterViewInit() {
    this.loadComponent();
  }

}

